import Image from "next/image";

import { cx } from "#ui/style.utils";

type ImageProps = Parameters<typeof Image>[0];

interface CheckImagesProps extends Omit<ImageProps, "src"> {
  value: string;
}

export function CheckImage({
  className,
  alt,
  value,
  ...props
}: CheckImagesProps) {
  return (
    <Image
      {...props}
      src={`data:image/png;base64,${value}`}
      alt={alt}
      width={600}
      height={275}
      className={cx("h-auto w-full", className)}
    />
  );
}
